import { useDispatch } from 'react-redux';
import { Table, Row, Col, Space, Typography, Popover, Slider, InputNumber, Button } from 'antd';
import { Edit2Icon } from 'lucide-react';
import { useState } from 'react';
import { updateCompanyPortfolio } from '../../../api/companyApi';

const MaxWeightEditor = ({ value, onSubmit, onCancel }) => {
    const [weight, setWeight] = useState(value * 100);

    const handleSubmit = () => {
        onSubmit(weight / 100);
    };

    return (
        <div className="p-4 w-64">
            <Typography.Text className="block mb-2">Adjust Maximum Weight</Typography.Text>
            <Space direction="vertical" className="w-full">
                <Row align="middle" gutter={16}>
                    <Col flex="auto">
                        <Slider
                            min={0}
                            max={100}
                            value={weight}
                            onChange={(value) => setWeight(value)}
                            step={1}
                        />
                    </Col>
                    <Col flex="none">
                        <InputNumber
                            min={0}
                            max={100}
                            value={weight}
                            onChange={(value) => setWeight(value)}
                            formatter={(value) => `${value}%`}
                            parser={(value) => value.replace('%', '')}
                            className="w-20"
                        />
                    </Col>
                </Row>
                <Row justify="end" gutter={8}>
                    <Col>
                        <Button size="small" onClick={onCancel}>Cancel</Button>
                    </Col>
                    <Col>
                        <Button size="small" type="primary" onClick={handleSubmit}>
                            Update
                        </Button>
                    </Col>
                </Row>
            </Space>
        </div>
    );
};

const CompanyPortfolios = ({ portfolios }) => {
    const dispatch = useDispatch();
    const [editingId, setEditingId] = useState(null);

    const handleUpdateWeight = async (portfolioId, newWeight) => {
        try {
            await dispatch(updateCompanyPortfolio({
                portfolioId,
                companyId: localStorage.getItem('cid'),
                updateFields: {
                    max_weight: newWeight
                }
            })).unwrap();
            setEditingId(null);
        } catch (error) {
            console.error('Failed to update portfolio weight:', error);
        }
    };

    const columns = [
        { title: 'Name', dataIndex: 'name', key: 'name' },
        {
            title: 'Targets',
            dataIndex: 'targets',
            key: 'targets',
            render: (targets) => (
                <Typography.Text>{targets.equity} / {targets.fixed}</Typography.Text>
            )
        },
        {
            title: "Category",
            dataIndex: ['tags', 'category'],
            key: 'category',

        },
        { title: "Company", dataIndex: 'company.name', key: 'company' },
        {
            title: 'Max Weight',
            dataIndex: 'company',
            key: 'max_weight',
            render: (company, record) => {
                const weight = (company?.max_weight || 1.0) * 100;

                return (
                    <Popover
                        open={editingId === record.id}
                        trigger="click"
                        onOpenChange={(visible) => {
                            if (!visible) setEditingId(null);
                        }}
                        content={
                            <MaxWeightEditor
                                value={company?.max_weight || 1.0}
                                onSubmit={(newWeight) => handleUpdateWeight(record.id, newWeight)}
                                onCancel={() => setEditingId(null)}
                            />
                        }
                    >
                        <div className="flex items-center gap-2 cursor-pointer" onClick={() => setEditingId(record.id)}>
                            <span>{weight.toFixed(1)}%</span>
                            <Edit2Icon size={16} className="text-gray-500" />
                        </div>
                    </Popover>
                );
            }
        }
    ];

    return (
        <Table dataSource={portfolios} columns={columns} rowKey={'id'} />
    );
};

export default CompanyPortfolios;